import { FormWithRedux } from '../../FormWithRedux';

export class ACCBISTMentalStateForm extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('alterationInMentalStateSubform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        if (identifier == 'lossOfConsciousnessDuration') {
            return this.getValue('lossOfConsciousness') == true;   
        }
        else if (identifier == 'retrogradeAmnesiaDuration') {
            return this.getValue('retrogradeAmnesia') == true;   
        }

        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        if(identifier == 'retrogradeAmnesia' || identifier == 'alteredMentalState' || identifier == 'lossOfConsciousness') {
            return this.getValue('alterationInMentalState') == true;  
        }
        else if (identifier == 'lossOfConsciousnessDuration') {
            return this.getValue('lossOfConsciousness') == true;   
        }
        else if (identifier == 'retrogradeAmnesiaDuration') {
            return this.getValue('retrogradeAmnesia') == true;   
        }

        return true;
    }

    getValueType(identifier) {
        if(identifier == 'lossOfConsciousnessDuration'
            || identifier == 'retrogradeAmnesiaDuration') {
            return 'double';
        }
        else if(identifier == 'lossOfConsciousness'
        || identifier == 'retrogradeAmnesia'
        || identifier == 'alteredMentalState') {
            return 'boolean';
        }

        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-MentalStateForm.js